
//ローカルテスト用
//const commonURL = "http://localhost:3030"
// const commonURL = 'http://192.168.34.4:3030'

//本番用
const commonURL = 'https://sss2.digitalstage.jp'

export const apiURLSiteSearch = commonURL + '/siteSearch'
export const apiURLFullTextSearch = commonURL + '/fullTextSearch'
export const apiURLPrioritySettingSearch = commonURL + '/prioritySettingSearch'

//画面毎の保存処理
export const apiURLCreateSiteSearch = commonURL + '/createSiteSearch'
export const apiURLSettingSiteSearch = commonURL + '/settingSiteSearch'
export const apiURLConfirmSiteSearch = commonURL + '/confirmSiteSearch'
